import { gql } from '@apollo/client';

export const CURRENT_USER_OPERABLE_WAREHOUSE_IDS = gql`
  query CurrentUserOperableWarehouseIds {
    currentUserOperableWarehouseIds
  }
`;
